import { Helmet } from "react-helmet-async";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "../Style.css";

function TermsPage() {
  return (
    <>
      <Helmet>
        <title>Website Disclaimer | Own Your Money</title>
        <meta
          name="description"
          content="Important disclaimer regarding Own Your Money's financial coaching services in North Carolina and in the United States. Educational information only, not financial advice."
        />
        <link
          rel="canonical"
          href="https://www.ownyourmoney.biz/websitedisclaimer"
        />
        <meta name="robots" content="noindex, follow" />
        <meta
          property="og:title"
          content="Website Disclaimer | Own Your Money"
        />
        <meta
          property="og:description"
          content="Important disclaimer regarding Own Your Money's financial coaching services in North Carolina and in the United States. Educational information only, not financial advice."
        />
        <meta
          property="og:url"
          content="https://www.ownyourmoney.biz/websitedisclaimer"
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="%PUBLIC_URL%/og-image.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="geo.region" content="US-NC" />
        <meta name="geo.country" content="United States" />
        <meta name="geo.placename" content="Holly Springs, NC" />
        <meta name="geo.position" content="35.65;-78.83" />
        <meta name="ICBM" content="35.65, -78.83" />
        <meta name="language" content="en-US" />
      </Helmet>
      <Header />
      <div className="legal-page">
        <div className="legal-header">
          <h1>Website Disclaimer</h1>
          <h2>Own Your Money | Financial Wellness Coaching</h2>
        </div>

        <p>
          The information provided on this website is for educational and
          informational purposes only and is not intended as financial, legal,
          or tax advice. By accessing this site or engaging with Own Your Money
          coaching services, you acknowledge and agree to the following:
        </p>

        <ol className="disclaimer-list">
          <li>
            <h3>1. Coaching Services</h3>
            <p>
              Own Your Money offers financial coaching designed to support
              personal growth, financial clarity, and behavior change. Coaching
              is not therapy, investment management, accounting, or legal
              counsel. Wendy Toh is a
              <strong> Certified Personal Financial Wellness Consultant</strong>{" "}
              and financial coach—not a licensed financial advisor, CPA, or
              attorney.
            </p>
          </li>

          <li>
            <h3>2. Personal Responsibility</h3>
            <p>
              Clients are responsible for their own financial decisions,
              actions, and outcomes. Coaching provides tools, guidance, and
              emotional support—but does not make decisions on behalf of
              clients. You are encouraged to seek professional advice when
              appropriate.
            </p>
          </li>

          <li>
            <h3>3. Confidentiality</h3>
            <p>
              Any personal or financial information shared during coaching
              sessions will be treated with respect and discretion. However,
              coaching is not protected by legal confidentiality privileges such
              as attorney-client or therapist-client relationships.
            </p>
          </li>

          <li>
            <h3>4. Acceptable Use</h3>
            <p>
              You agree to use this website and its content for lawful,
              personal, and non-commercial purposes only. You may not:
            </p>
            <ul>
              <li>
                Copy, reproduce, or distribute content without written
                permission
              </li>
              <li>
                Use the site to transmit spam, malware, or harmful content
              </li>
              <li>
                Attempt to gain unauthorized access to any part of the site or
                its systems
              </li>
              <li>
                Misrepresent yourself or impersonate others while interacting
                with the site
              </li>
            </ul>
          </li>

          <li>
            <h3>5. Intellectual Property</h3>
            <p>
              All content on this website—including text, graphics, logos,
              images, downloads, and branding—is the property of Own Your Money
              and Wendy Toh unless otherwise stated. You may not use, reproduce,
              or distribute any materials without prior written consent.
            </p>
          </li>

          <li>
            <h3>6. Disclaimer of Warranties</h3>
            <p>
              This website is provided “as is” and “as available.” Own Your
              Money makes no warranties, express or implied, regarding the
              accuracy, reliability, or availability of the site or its content.
              We do not guarantee that the site will meet your expectations or
              be free from errors or interruptions.
            </p>
          </li>

          <li>
            <h3>7. Limitation of Liability</h3>
            <p>
              To the fullest extent permitted by law, Own Your Money and Wendy
              Toh shall not be liable for any damages arising from the use of
              this website or coaching services, including but not limited to
              direct, indirect, incidental, or consequential damages. In no
              event shall our total liability exceed the amount paid by you for
              coaching services.
            </p>
          </li>

          <li>
            <h3>8. Governing Law</h3>
            <p>
              This agreement shall be governed by and construed in accordance
              with the laws of the State of North Carolina, United States,
              without regard to its conflict of law principles.
            </p>
          </li>
        </ol>
      </div>
      <Footer />
    </>
  );
}
export default TermsPage;
